import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/data/faqs";
import BookingButton from "./BookingButton";

export default function FAQ({ items = FAQS, eyebrow = "Frequently Asked", title = "Questions worth asking before you book." }) {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 lg:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <div className="eyebrow mb-3">{eyebrow}</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight">{title}</h2>
        </div>

        <div className="border-t" style={{ borderColor: "var(--sano-border)" }}>
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border-b"
                style={{ borderColor: "var(--sano-border)" }}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 py-6 text-left hover:bg-[#F0EBE1] transition-colors px-2"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-serif-display text-xl sm:text-2xl leading-snug pr-4">{f.q}</span>
                  <span className="shrink-0 mt-1.5" style={{ color: "var(--sano-olive)" }}>
                    {isOpen ? <Minus size={18} strokeWidth={1.5} /> : <Plus size={18} strokeWidth={1.5} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-2 pb-6 -mt-2">
                    <p
                      className="text-base leading-relaxed max-w-3xl"
                      style={{ color: "var(--sano-ink-2)" }}
                      data-testid={`faq-answer-${i}`}
                    >
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm mb-5" style={{ color: "var(--sano-ink-2)" }}>
            Still wondering? Send me a note or call 929.272.6066 for a free phone consultation.
          </p>
          <BookingButton testid="faq-book-btn" />
        </div>
      </div>
    </section>
  );
}
